// Utility to export table data as CSV
// Usage: exportTableData(fetchPageData, totalPages, columns, filename)
// fetchPageData(page) should return a Promise resolving to the data for that page

export async function exportTableData(
  fetchPageData,
  totalPages,
  columns,
  filename = "export.csv",
) {
  let allRows = [];
  for (let page = 1; page <= totalPages; page++) {
    // eslint-disable-next-line no-await-in-loop
    const pageData = await fetchPageData(page);
    allRows = allRows.concat(pageData);
  }

  const csvRows = [];
  // Add header
  csvRows.push(
    columns.map((col) => col.header || col.label || col.key).join(","),
  );
  // Add data rows
  allRows.forEach((row) => {
    csvRows.push(
      columns
        .map((col) => {
          let value = row[col.key];
          if (typeof value === "string") {
            value = value.replace(/"/g, '""');
            if (
              value.includes(",") ||
              value.includes('"') ||
              value.includes("\n")
            ) {
              value = `"${value}"`;
            }
          }
          return value;
        })
        .join(","),
    );
  });

  const csvContent = csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
